import { render, staticRenderFns } from "./OwnerChangeList.vue?vue&type=template&id=0ba57a1a&scoped=true&"
import script from "./OwnerChangeList.vue?vue&type=script&lang=js&"
export * from "./OwnerChangeList.vue?vue&type=script&lang=js&"
import style0 from "./OwnerChangeList.vue?vue&type=style&index=0&id=0ba57a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba57a1a",
  null
  
)

export default component.exports